import React, { useState } from 'react'
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange'

const RefundProxyConfirmDialog = (props) => {
    const [selectedQuickReason, setSelectedQuickReason] = useState('')

    const quickReasons = [
        'Not working',
        'IP mismatch at purchase',
        'Country geolocation mismatch',
    ]

    const handleClose = () => {
        props.setOpenConfirmRefund(false)
        setSelectedQuickReason('')
    }

    const handleRefund = () => {
        try {
            props.refundProxy(selectedQuickReason)
        } catch (e) {
            throw e
        }
    }

    const handleQuickReasonClick = (reason) => {
        setSelectedQuickReason(reason)
    }

    const isReasonSelected = Boolean(selectedQuickReason)

    return (
        <>
            {props.openConfirmRefund && (
                <div className="shop-confirm-overlay" onClick={handleClose}>
                    <div className="shop-confirm-modal" onClick={(e) => e.stopPropagation()}>
                        <button
                            type="button"
                            onClick={handleClose}
                            className="shop-confirm-close"
                            aria-label="Close"
                        >
                            ✕
                        </button>

                        <h2 className="shop-confirm-title">Refund Proxy Confirm</h2>

                        <div className="shop-confirm-panel">
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 'var(--spacing-md)',
                                    marginBottom: 'var(--spacing-md)',
                                }}
                            >
                                <div className="shop-confirm-refund-icon-wrap">
                                    <CurrencyExchangeIcon
                                        className="shop-confirm-refund-icon"
                                        style={{ fontSize: 24 }}
                                    />
                                </div>
                                <div>
                                    <h3 className="shop-confirm-panel__heading">Proxy Refund</h3>
                                    <p className="shop-confirm-panel__sub">Request refund for proxy</p>
                                </div>
                            </div>

                            <p className="shop-confirm-body-text shop-confirm-panel__divider">
                                By clicking the refund button, a refund ticket for proxy{' '}
                                <span className="shop-confirm-mono shop-confirm-accent">
                                    {props.selectedProxy?.rentalid}
                                </span>{' '}
                                will be created.
                            </p>
                        </div>

                        <div style={{ marginBottom: 'var(--spacing-xl)' }}>
                            <p className="shop-confirm-section-title shop-confirm-section-title--inline">
                                Quick reason selection:
                            </p>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 'var(--spacing-sm)',
                                    marginTop: 'var(--spacing-md)',
                                }}
                            >
                                {quickReasons.map((reason) => (
                                    <button
                                        key={reason}
                                        type="button"
                                        onClick={() => handleQuickReasonClick(reason)}
                                        className={`shop-confirm-chip shop-confirm-chip--block${
                                            selectedQuickReason === reason ? ' shop-confirm-chip--active' : ''
                                        }`}
                                    >
                                        {reason}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div
                            className="shop-confirm-actions"
                            style={{
                                display: 'flex',
                                gap: 'var(--spacing-md)',
                                justifyContent: 'flex-end',
                            }}
                        >
                            <button
                                type="button"
                                onClick={handleClose}
                                className="btn btn-outline"
                                style={{ minWidth: '100px', height: '32px' }}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={handleRefund}
                                className="btn btn-outline shop-confirm-refund-btn"
                                style={{
                                    minWidth: '120px',
                                    height: '32px',
                                    opacity: isReasonSelected ? 1 : 0.5,
                                    cursor: isReasonSelected ? 'pointer' : 'not-allowed',
                                }}
                                disabled={!isReasonSelected}
                            >
                                Refund
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default RefundProxyConfirmDialog
